// extracted by mini-css-extract-plugin
export default {"search":"Serach_search__FvIPi","searchform":"Serach_searchform__2s-pY","userchat":"Serach_userchat__OHXrW"};